import { render, staticRenderFns } from "./Crediti.vue?vue&type=template&id=6fbc645c&scoped=true&"
import script from "./Crediti.vue?vue&type=script&lang=js&"
export * from "./Crediti.vue?vue&type=script&lang=js&"
import style0 from "./Crediti.vue?vue&type=style&index=0&id=6fbc645c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbc645c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fbc645c')) {
      api.createRecord('6fbc645c', component.options)
    } else {
      api.reload('6fbc645c', component.options)
    }
    module.hot.accept("./Crediti.vue?vue&type=template&id=6fbc645c&scoped=true&", function () {
      api.rerender('6fbc645c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Crediti.vue"
export default component.exports